import { useCallback, useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import Cookies from "universal-cookie";
import { format } from "date-fns";
import ReactRouterPrompt from "react-router-prompt";

import { FaPencilAlt, FaCheck } from "react-icons/fa";
import {
  FaFileDownload as FileIcon,
  FaAngleDown as ArrowDown,
  FaAngleUp as ArrowUp,
} from "react-icons/fa";

import { Title, LoadingTitle } from "../../components/Title";
import LoadingIcon from "../../components/LoadingIcon";
import { DeliveryOrder } from "./DeliveryOrder";
import "../../stylesheets/ShipmentInfo.scss";
import { toast } from "react-toastify";
import { loadingAnimation } from "../../components/scripts/functions";
import "../../stylesheets/Truckers.scss";
import "../../stylesheets/Warehouse.scss";
import BackwardArrow from '../../assets/nav-bar-icons/arrow-left.svg';
import ForwardArrow from '../../assets/nav-bar-icons/arrow-right.svg';
import { HiDocumentDownload } from "react-icons/hi";
import { IoCloseSharp } from "react-icons/io5";
import { getFileUrl } from "../../utils/fileUrl";
import "../../stylesheets/Modal.scss";
import ToggleSwitch from "../../components/ToggleSwitch";
export const ShipmentInfo = () => {
  const cookies = new Cookies();
  const token = cookies.get("token_user");
  const URL = process.env.REACT_APP_API_URL + "/user";
  const [shipment, setShipment] = useState();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);
  const role = Number(cookies.get("role_user") || cookies.get("role"));

  const [state7501, setState7501] = useState(null);

  //ISF, Upload Documents, Shipment release Menus
  const [contentDisplay1, setContentDisplay1] = useState([]);
  const [opened1, setOpened1] = useState(false); //To check if the menu is opened

  const [contentDisplay2, setContentDisplay2] = useState([]);
  const [opened2, setOpened2] = useState(false);

  const [contentDisplay3, setContentDisplay3] = useState([]);
  const [opened3, setOpened3] = useState(false);

  const [withoutISF, setWithoutISF] = useState(false);
  const [ISFBlockedStep, setISFBlockedStep] = useState({
    opacity: "0.5",
    pointerEvents: "none",
  });

  const [userNote, setUserNote] = useState("");
  const [noteLoading, setNoteLoading] = useState(false);
  const [noteSuccess, setNoteSuccess] = useState(false);
  const [newRefNumber, setNewRefNumber] = useState();
  const [uploadError, setUploadError] = useState([]);

  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [aditionalDelivery, setAditionalDelivery] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { filteredShipmentIds, filter } = location.state || {};

  const initialIndex = filteredShipmentIds
    ? filteredShipmentIds.indexOf(parseInt(id, 10))
    : 0;

  const [currentShipmentIndex, setCurrentShipmentIndex] = useState(initialIndex);
  const checkDateValidity = (date) => {
    const date_parsed = new Date(date);
    return !isNaN(date_parsed.getTime()) && date !== "0000-00-00";
  };

  const fetchShipmentData = async (shipmentId) => {
    setLoading(true);
    try {
      const response = await fetch(`${URL}/shipments/details/${shipmentId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();

      const master_bill = [];
      const house_bill = [];

      data?.shipment?.bill_lading?.forEach((bill) => {
        if (bill?.is_master_bill_lading) {
          master_bill.push(bill?.bill_lading);
        } else {
          house_bill.push(bill?.bill_lading);
        }
      });

      data.shipment.master_bill_lading = master_bill.join(", ");
      data.shipment.house_bill_lading = house_bill.join(", ");

      setShipment(data.shipment);
      loadMissingInfos(shipmentId);
    } catch (e) {
      console.error("Error fetching shipment data", e);
      toast.error("Unable to fetch shipment data, please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleNavigation = (direction) => {
    if (!filteredShipmentIds || filteredShipmentIds.length <= 1) return;

    if (direction === 'prev') {
      const prevIndex = currentShipmentIndex === 0
        ? filteredShipmentIds.length - 1
        : currentShipmentIndex - 1;
      setCurrentShipmentIndex(prevIndex);
    } else if (direction === 'next') {
      const nextIndex = currentShipmentIndex === filteredShipmentIds.length - 1
        ? 0
        : currentShipmentIndex + 1;
      setCurrentShipmentIndex(nextIndex);
    }
  };

  useEffect(() => {
    if (filteredShipmentIds && filteredShipmentIds.length > 0) {
      fetchShipmentData(filteredShipmentIds[currentShipmentIndex]);

      // Update URL to reflect the current shipment
      navigate(`/shipments/${filteredShipmentIds[currentShipmentIndex]}`, {
        state: { filteredShipmentIds, filter },
        replace: true, // <== key line
      });
    }
  }, [filteredShipmentIds, currentShipmentIndex, filter]);

  const shouldShowButtons = filter && filteredShipmentIds?.length > 1;

  /* Styles */
  const buttonStyle = {
    backgroundColor: "var(--green)",
    marginTop: "1.3rem",
    marginLeft: "auto",
    width: "fit-content",
    display: "block",
    minWidth: "9.2rem",
    height: "3rem",
    border: "1px solid white",
    borderRadius: "5px",
    cursor: "pointer",
    color: "white",
  };

  const greenAndBoldText = {
    color: "var(--green)",
    fontWeight: "bolder",
  };

  const greenAndBoldCircle = {
    border: "2px solid var(--green)",
    backgroundColor: "var(--global-green)",
  };

  /* Handle ISF */
  const handleWithoutISF = async (e) => {
    setWithoutISF(true);
    e.preventDefault();

    const data = {
      isf_num: "N/A",
      date: "N/A",
    };

    try {
      loadingAnimation(true);
      const resp = await fetch(`${URL}/shipments/${id}/isf_no`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (resp.status == 200) {
        var updateShipment = shipment;
        updateShipment.isf_transaction_no = "N\\A";
        setShipment(updateShipment);
        toggleMenu2();
        loadingAnimation(false);
      } else {
        loadingAnimation(false);
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
        navigate(0);
      }
    } catch (e) {
      loadingAnimation(false);
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  /* Toggle Steps */
  const toggleMenu1 = () => {
    if (opened1) {
      setContentDisplay1({
        display: "none",
      });
      setOpened1(false);
    } else {
      setContentDisplay1({
        display: "block",
        marginBottom: "1rem",
        opacity: 1,
      });
      setOpened1(true);
    }
  };

  const toggleMenu2 = () => {
    if (opened2) {
      setContentDisplay2({
        display: "none",
      });
      setOpened2(false);
    } else {
      setContentDisplay2({
        display: "block",
        marginBottom: "1rem",
        opacity: 1,
      });
      setOpened2(true);
    }
  };

  const toggleMenu3 = () => {
    if (opened3) {
      setContentDisplay3({
        display: "none",
      });
      setOpened3(false);
    } else {
      setContentDisplay3({
        display: "block",
        marginBottom: "1rem",
        opacity: "1",
      });
      setOpened3(true);
    }
  };

  const checkStep = (shipment) => {
    if (shipment) {
      if (
        !shipment.isf_transaction_no ||
        shipment.status === "AWAITING ARRIVAL" ||
        shipment.status === "SUBMITTED"
      ) {
        toggleMenu1();
      } else if (shipment.status === "PENDING DOCUMENTS") {
        toggleMenu2();
      } else {
        toggleMenu3();
      }
    }
  };

  const isStep2Done = () => {
    const mode = Number(shipment?.mode_of_transport);
    const noIsf = [30, 20, 21, 40, 41].includes(mode);
    if (
      shipment.status != "PENDING DOCUMENTS" &&
      shipment.status != "AWAITING ARRIVAL" &&
      shipment.status != "SUBMITTED" &&
      (noIsf || shipment.isf_transaction_no)
    ) {
      return true;
    }
    return false;
  };

  const isStep3Active = () => {
    if (
      shipment.status === "PENDING RELEASE" ||
      shipment.status === "UNDER CBP HOLD"
    ) {
      return true;
    }
    return false;
  };

  const toggleIgnoreShipment = async (shipmentId, ignore, category) => {
    try {
      const response = await fetch(`${URL}/shipments/toggle-ignore`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ shipment_id: shipmentId, ignore, category }), // Include category dynamically
      });

      if (response.status === 200) {
        toast.success("Shipment ignore status updated successfully!");
        getShipmentData(); // Refresh the shipment data after toggling ignore
      } else {
        const errorData = await response.json();
        toast.error(
          errorData.error || "Something went wrong, please try again later."
        );
      }
    } catch (error) {
      toast.error("Unable to update shipment ignore status, please try again later.");
      console.error(error);
    }
  };

  const toggleShowOnHome = async () => {
    let currentVal = shipment?.show_on_home_user ? 1 : 0;
    let nextVal = currentVal ? 0 : 1;
    try {
      const response = await fetch(`${URL}/shipments/${shipment.id}/show_on_home`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ show_on_home_user: nextVal }),
      });

      if (response.ok) {
        setShipment((prev) => ({ ...prev, show_on_home_user: nextVal }));
        toast.success(
          nextVal ? "Shipment will be shown on home screen" : "Shipment hidden from home screen"
        );
      } else {
        toast.error("Could not complete request. Please, try again!");
      }
    } catch (error) {
      toast.error("Could not complete request. Please, try again!");
      console.error(error);
    }
  };


  /* Upload Files */
  const DropZone = () => {
    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
      var errors = [];
      if (rejectedFiles.length > 0) {
        errors = rejectedFiles.map(
          (file) =>
            "Couldn't upload " + file.file.path + " - " + file.errors[0].message
        );
      }

      var re = /(?:\.([^.]+))?$/;
      const allowedExts = ["pdf", "xls", "xlsx", "png", "jpg", "jpeg", "docx", "doc"];

      acceptedFiles.forEach(async (file) => {
        const filePathOrName = file.path || file.name || "";
        const path_name = `changed-${filePathOrName}`;
        Object.defineProperty(file, "name", {
          writable: true,
          value: path_name,
        });
        const match = re.exec(filePathOrName);
        const ext = match && match[1] ? match[1].toLowerCase() : "";
        if (allowedExts.includes(ext)) {
          const formData = new FormData();
          formData.append("file", file);

          try {
            loadingAnimation(true);
            const resp = await fetch(`${URL}/shipments/${id}/upload_doc`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: formData,
            });
            const data = await resp.json();

            if (resp.status == 200) {
              var updateShipment = shipment;
              updateShipment.documents.push({
                shipment_id: shipment.id,
                document_type: "",
                path: data?.path_to_file,
              });
              setShipment({ ...shipment, documents: updateShipment.documents });
              loadingAnimation(false);
            } else {
              loadingAnimation(false);
              toast.error(
                "Something went wrong. Please, try again in a few minutes!"
              );
            }
          } catch (error) {
            loadingAnimation(false);
            toast.error(
              "Something went wrong. Please, try again in a few minutes!"
            );
          }
        } else {
          errors.push(
            "Couldn't upload " +
            (file.path || file.name || "file") +
            " - " +
            "File type should be pdf, excel, word or image"
          );
        }
      });

      setUploadError(errors);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      accept: {
        "image/*": [".jpeg", ".jpg", ".png", ".JPEG", ".JPG", ".PNG"],
        "application/pdf": [".pdf", ".PDF"],
        "application/vnd.ms-excel": [".xls", ".XLS"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx", ".XLSX"],
        "application/msword": [".doc", ".DOC"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx", ".DOCX"],
      },
    });

    return (
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <p>Drag 'n' drop some files here, or click to select files</p>
        )}
      </div>
    );
  };

  const deleteFile = async (e, doc) => {
    e.preventDefault();

    try {
      loadingAnimation(true);
      const resp = await fetch(`${URL}/shipments/${id}/delete_doc`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ path: doc.path }),
      });

      const res = await resp.json();
      if (res?.success == "Document deleted successfully") {
        var updateShipment = shipment;
        var docs = shipment.documents.filter((file) => file.path != doc.path);
        loadingAnimation(false);
        setShipment({ ...shipment, documents: docs });
      }
    } catch (e) {
      loadingAnimation(false);
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  const handleDocType = async (e, type) => {
    if (type.submitted) {
      const resp = await fetch(`${URL}/shipments/${id}/unset_type`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ types: type.type }),
      });

      const res = await resp.json();

      if (res.type_unset) {
        var updateShipment = shipment;
        var types = updateShipment.types.map((curType) => {
          if (curType.type == type.type) {
            curType["submitted"] = 0;
          }
          return curType;
        });
        setShipment({ ...shipment, types: types });

        if (res.status == "PENDING DOCUMENTS") {
          setShipment({ ...shipment, status: "PENDING DOCUMENTS" });
          setStep2(true);
          setStep3(false);
        }
      }
    } else {
      const resp = await fetch(`${URL}/shipments/${id}/set_type`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ types: type.type }),
      });

      const res = await resp.json();

      if (res.type_set) {
        var updateShipment = shipment;
        var types = updateShipment.types.map((curType) => {
          if (curType.type == type.type) {
            curType["submitted"] = 1;
          }

          return curType;
        });
        setShipment({ ...shipment, types: types });

        if (res.status == "PENDING RELEASE") {
          setShipment({ ...shipment, status: "PENDING RELEASE" });
          toggleMenu2();
          toggleMenu3();
          setStep2(true);
        }
      }
    }
  };

  const containerNumbers = (containers) => {
    var cont_numbers = "";

    for (let i = 0; i < containers.length; i++) {
      cont_numbers += containers[i].container_no + ", ";
    }

    return <p>{cont_numbers.slice(0, cont_numbers.length - 2)}</p>;
  };

  /* Notes */
  const handleNoteUpload = async (e) => {
    e.preventDefault();
    setNoteLoading(true);

    const data = {
      note: userNote,
    };

    try {
      loadingAnimation(true);
      const resp = await fetch(`${URL}/shipments/${id}/add_comment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const res = await resp.json();

      if (resp.status == 200) {
        loadingAnimation(false);
        setShipment({ ...shipment, comment: res.message });
        setNoteLoading(false);
        setNoteSuccess(true);
      } else {
        loadingAnimation(false);
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
        setNoteLoading(false);
      }
    } catch (e) {
      loadingAnimation(false);
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  /* Delivery Orders */
  const deliveryOrders = (params) => {
    const { numberOfDeliveries } = params;

    var deliveries = shipment?.delivery_orders
      ? shipment?.delivery_orders?.length
      : 0;
    var num = deliveries + aditionalDelivery;

    const handleNewDelete = (i) => {
      setAditionalDelivery(aditionalDelivery - 1);
    };
    const handleDelete = (i) => {
      delete deliveries[i];
      getShipmentData();
    };

    return (
      <div>
        {deliveries + aditionalDelivery < 1 ? (
          <p className="empty">
            Create your first delivery order by clicking New Delivery Order
            above
          </p>
        ) : (
          <>
            {[...Array(deliveries + aditionalDelivery)].map((_, i) => (
              <div key={i}>
                <DeliveryOrder
                  x={i}
                  id={id}
                  handleDelete={() => {
                    handleDelete(i);
                  }}
                  handleNewDelete={() => {
                    handleNewDelete(i);
                  }}
                />
              </div>
            ))}
          </>
        )}
      </div>
    );
  };

  /* Reference Number */
  const handleRefNumberUpdate = async (e) => {
    e.preventDefault();

    const data = {
      reference_no: newRefNumber,
    };

    try {
      loadingAnimation(true);
      const resp = await fetch(`${URL}/shipments/${id}/reference_no`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (resp.status == 200) {
        loadingAnimation(false);
        setShipment({ ...shipment, customer_reference_no: newRefNumber });
        setNewRefNumber("");
      } else {
        loadingAnimation(false);
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
      }
    } catch (e) {
      loadingAnimation(false);
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  const getShipmentData = async () => {
    setLoading(true);
    try {
      const url = `${URL}/shipments/details/${id}`;
      const resp = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await resp.json();

      const master_bill = [];
      const house_bill = [];

      data?.shipment?.bill_lading?.forEach((bill) => {
        if (bill?.is_master_bill_lading) {
          master_bill.push(bill?.bill_lading);
        } else {
          house_bill.push(bill?.bill_lading);
        }
      });

      data.shipment.master_bill_lading = master_bill.join(", ");
      data.shipment.house_bill_lading = house_bill.join(", ");

      setShipment(data.shipment);
      checkStep(data.shipment);
      setLoading(false);

      setState7501(data["7501_reviewed"]);
      loadMissingInfos(id);
    } catch (e) {
      //console.log(e);
      alert("Server not responding, please contact us.");
    }
  };

  // ── Missing Info Checklist ───────────────────────────────────────────────────
  const [missingInfos, setMissingInfos] = useState([]);
  const [responseValues, setResponseValues] = useState({});

  const loadMissingInfos = async (shipmentId) => {
    try {
      const resp = await fetch(`${URL}/shipments/${shipmentId}/missing-info`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await resp.json();
      if (resp.ok) {
        setMissingInfos(data.missing_info || []);
        const initialResponses = {};
        (data.missing_info || []).forEach(item => {
          initialResponses[item.id] = item.value || "";
        });
        setResponseValues(initialResponses);
      }
    } catch (e) {
      console.error("Failed to load missing info checklist", e);
    }
  };

  const handleResponseChange = (itemId, val) => {
    setResponseValues(prev => ({
      ...prev,
      [itemId]: val
    }));
  };

  const saveMissingInfoValue = async (itemId) => {
    const textVal = responseValues[itemId]?.trim();
    if (!textVal) {
      toast.error("Please input response text before saving.");
      return;
    }
    try {
      const resp = await fetch(`${URL}/shipments/${id}/missing-info/${itemId}/value`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ value: textVal })
      });
      const data = await resp.json();
      if (resp.ok) {
        toast.success("Missing information saved successfully!");
        setMissingInfos(prev =>
          prev.map(item => item.id === itemId ? data.item : item)
        );
      } else {
        toast.error(data.message || "Failed to save response.");
      }
    } catch (e) {
      console.error("Error saving missing info value", e);
      toast.error("Could not save response.");
    }
  };

  const getUserData = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${URL}/profile`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await resp.json();
      setUser(data);
      setLoading(false);
    } catch (e) {
      //console.log(e);
      alert("Server not responding, please contact us.");
    }
  };

  useEffect(() => {
    getShipmentData();
    getUserData();
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const review7501 = (ship_id) => {
    const url = `${URL}/shipments/toggle-reviewed`;
    const body = {
      shipment_ids: [ship_id],
    };
    loadingAnimation(true);
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((res) => {
        loadingAnimation(false);
        if (res.reviewed === true) {
          setState7501(1);
        } else if (res.reviewed === false) {
          setState7501(0);
        }
      })
      .catch((e) => {
        loadingAnimation(false);
        //console.log(e);
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
      });
  };

  // near top of component (or reuse existing flag)
  const isAir =
    Number(shipment?.mode_of_transport) === 40 ||
    Number(shipment?.mode_of_transport) === 41 ||
    Number(shipment?.transport_mode?.code) === 40 ||
    Number(shipment?.transport_mode?.code) === 41;

  const isTrucker = Number(shipment?.mode_of_transport) === 30;

  const isRail =
    Number(shipment?.mode_of_transport) === 20 ||
    Number(shipment?.mode_of_transport) === 21 ||
    Number(shipment?.transport_mode?.code) === 20 ||
    Number(shipment?.transport_mode?.code) === 21;

  const isNoIsfMode = isAir || isTrucker || isRail;
  const step2Label = isNoIsfMode ? "1" : "2";
  const step3Label = isNoIsfMode ? "2" : "3";

  const [supplementaryFileArray, setSupplementaryFileArray] = useState([]);

  useEffect(() => {
    if (shipment?.supplementary_documents) {
      setSupplementaryFileArray(shipment.supplementary_documents);
    } else {
      setSupplementaryFileArray([]);
    }
  }, [shipment]);

  // ── Document selection modal state ──
  const [showDocModal, setShowDocModal] = useState(false);
  const [docList, setDocList] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState(new Set());
  const [docLoading, setDocLoading] = useState(false);
  const [docDownloading, setDocDownloading] = useState(false);

  const openDocumentModal = async () => {
    setShowDocModal(true);
    setDocLoading(true);
    try {
      const res = await fetch(
        `${URL}/shipments/${id}/list-documents`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error(`Server responded ${res.status}`);
      const data = await res.json();
      const docs = data.documents || [];
      setDocList(docs);
      setSelectedDocs(new Set(docs.map((d) => d.path)));
    } catch (err) {
      console.error("Failed to list documents:", err);
      toast.error("Could not load document list.");
      setShowDocModal(false);
    } finally {
      setDocLoading(false);
    }
  };

  const toggleDocSelection = (path) => {
    setSelectedDocs((prev) => {
      const next = new Set(prev);
      if (next.has(path)) next.delete(path);
      else next.add(path);
      return next;
    });
  };

  const toggleSelectAll = () => {
    if (selectedDocs.size === docList.length) {
      setSelectedDocs(new Set());
    } else {
      setSelectedDocs(new Set(docList.map((d) => d.path)));
    }
  };

  const handleDownloadSelected = async () => {
    if (selectedDocs.size === 0) {
      toast.error("Please select at least one document.");
      return;
    }
    setDocDownloading(true);
    try {
      const res = await fetch(
        `${URL}/shipments/${id}/combine-documents`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ files: Array.from(selectedDocs) }),
        }
      );
      if (!res.ok) throw new Error(`Server responded ${res.status}`);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Entry summary package - ${shipment.file_number}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
      setShowDocModal(false);
    } catch (err) {
      console.error("Download combined PDF failed:", err);
      toast.error("Failed to download combined documents.");
    } finally {
      setDocDownloading(false);
    }
  };
  const isShipmentsOnly = role === 11 || String(role) === "11";
  return (
    <>
      <ReactRouterPrompt when={newRefNumber}>
        {({ isActive, onConfirm, onCancel }) => {
          if (isActive && newRefNumber) {
            if (
              window.confirm(
                "The reference number wasn't saved. Are you sure you want to leave?"
              )
            ) {
              onConfirm();
            } else {
              onCancel();
            }
          }
        }}
      </ReactRouterPrompt>

      {loading ||
        typeof shipment === "undefined" ||
        typeof user === "undefined" ? (
        <>
          <LoadingTitle />
          <div className="page-content loading"></div>
        </>
      ) : (
        <>
          <Title
            title={`Shipment #${shipment.file_number}`}
            links={[]}
            extra={
              <button
                onClick={() => navigate(-1)}
                className="back-button"
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--link-color)",
                  fontSize: "1rem",
                  cursor: "pointer",
                  padding: 0
                }}
              >
                ← Back
              </button>
            }
          />
          <br />
          {shouldShowButtons && (
            <div className="navigation-arrows">
              <button
                className="arrow-btn"
                onClick={() => handleNavigation('prev')}
                disabled={loading || filteredShipmentIds.length <= 1}
                title="Previous shipment"
              >
                <img src={BackwardArrow} alt="Backward Arrow" className="arrow-icon" />
                <span className="arrow-text">Previous Shipment</span>
              </button>

              <button
                className="arrow-btn"
                onClick={() => handleNavigation('next')}
                disabled={loading || filteredShipmentIds.length <= 1}
                title="Next shipment"
              >
                <span className="arrow-text">Next Shipment</span>
                <img src={ForwardArrow} alt="Forward Arrow" className="arrow-icon" />
              </button>
            </div>
          )}
          <br />
          <div id="grey-line"></div>

          <div className="page-content">
            <div id="shipment-info">
              <div className="left-side">
                <div className="form-process">
                  {!isAir && !isTrucker && !isRail && (
                    <div className="form-step" id="step-1">
                      <div
                        className={`circle-completed`}
                        style={
                          shipment.isf_transaction_no
                            ? greenAndBoldCircle
                            : opened1
                              ? {
                                backgroundColor: "var(--green)",
                              }
                              : {
                                border: "2px solid var(--border-color)",
                                backgroundColor: "white",
                              }
                        }
                      >
                        {/*Progress circle */}
                        {shipment.isf_transaction_no ? (
                          <span style={greenAndBoldText}>✓</span>
                        ) : (
                          <span
                            style={
                              opened1
                                ? {
                                  color: "white",
                                }
                                : {
                                  color: "black",
                                  fontWeight: "lighter",
                                }
                            }
                          >
                            1
                          </span>
                        )}
                      </div>

                      <div className="form-body">
                        <p className="form-title" onClick={toggleMenu1}>
                          <span
                            style={
                              shipment.isf_transaction_no || opened1
                                ? greenAndBoldText
                                : { color: "black" }
                            }
                          >
                            ISF Submitted
                          </span>
                          <span className="arrow">{opened1 ? <ArrowUp /> : <ArrowDown />}</span>
                        </p>

                        {shipment.isf_transaction_no ? (
                          <div className="form-content" style={contentDisplay1}>
                            <p>
                              {shipment.isf_transaction_no === "N\\A"
                                ? "ISF submitted by client."
                                : shipment.isf_transaction_no === "ISF filed by another broker" || shipment.isf_transaction_no === "ISF filed by a different broker"
                                  ? "Filed by a different broker"
                                  : `Date filed: ${checkDateValidity(shipment.isf_submit_date) === true
                                    ? format(new Date(shipment.isf_submit_date), "MM/dd/yyyy")
                                    : "NOT AVAILABLE"
                                  }`}
                            </p>
                          </div>
                        ) : (
                          <div className="form-content" style={contentDisplay1}>
                            <div className="isf-buttons_container">
                              <div className="checkbox" onClick={handleWithoutISF}></div>
                              <p>ISF was submitted</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {!isShipmentsOnly && (
                    <div
                      className="form-step"
                      id="step-2"
                      style={
                        isAir || isTrucker || isRail
                          ? {}
                          : (shipment.isf_transaction_no ? {} : ISFBlockedStep)
                      }
                    >
                      <div
                        className="circle-completed"
                        style={
                          isStep2Done()
                            ? greenAndBoldCircle
                            : opened2
                              ? {
                                backgroundColor: "var(--green)",
                              }
                              : {
                                border: "2px solid var(--border-color)",
                                backgroundColor: "white",
                              }
                        }
                      >
                        {shipment.status == "RELEASED" ||
                          shipment.status == "PENDING RELEASE" ? (
                          <span style={greenAndBoldText}>✓</span>
                        ) : (
                          <span
                            style={
                              opened2 && !step2
                                ? { color: "black" }
                                : opened2 && step2
                                  ? { color: "white" }
                                  : { color: "black", fontWeight: "lighter" }
                            }
                          >
                            {step2Label}
                          </span>
                        )}
                      </div>
                      <div className="form-body">
                        <p className="form-title" onClick={toggleMenu2}>
                          <span
                            style={
                              isStep2Done() || opened2
                                ? greenAndBoldText
                                : { color: "black" }
                            }
                          >
                            Upload Documents
                          </span>
                          <span className="arrow">
                            {opened2 ? <ArrowUp /> : <ArrowDown />}
                          </span>
                        </p>
                        <div className="form-content" style={contentDisplay2}>
                          {shipment.documents.length > 0 && (
                            <div className="docs-wrapper">
                              {shipment.documents.map((doc, index) => {
                                if (doc.document_type === "7501" || doc.document_type === "7512") {
                                  return null; // skip this document
                                } else {
                                  return (
                                    <div className="doc-container left" key={index}>
                                      <div className="icon-container">
                                        <div className="icon green">
                                          <HiDocumentDownload />
                                        </div>
                                        <a
                                          href="#"
                                          onClick={(e) => deleteFile(e, doc)}
                                          className="delete"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                          >
                                            <path
                                              d="M1 1L15 15M15 1L1 15"
                                              stroke="#FF0000"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </a>
                                      </div>

                                      <a
                                        href={getFileUrl(doc.path)}
                                        target="_blank"
                                      >
                                        <div className="document-info">
                                          <p className="file-name">
                                            <a
                                              href={getFileUrl(doc.path)}
                                              target="_blank"
                                            >
                                              {doc.path.substring(doc.path.lastIndexOf("/") + 1).replace('"', "")}
                                            </a>
                                          </p>
                                        </div>
                                      </a>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          )}

                          {shipment.document_note && (
                            <div className="missing-doc_msg">
                              <div className="warning-circle">
                                <p>!</p>
                              </div>
                              <p className="warning-msg">{shipment.document_note}</p>
                            </div>
                          )}

                          {uploadError && uploadError.length > 0 && (
                            <div className="missing-doc_msg upload-error">
                              <div className="warning-circle">
                                <p>!</p>
                              </div>
                              <p className="warning-msg">
                                {uploadError.map((i, idx) => (
                                  <span key={idx}>
                                    {i}
                                    <br />
                                  </span>
                                ))}
                              </p>
                            </div>
                          )}

                          <DropZone />

                          <div className="files_summary">
                            {shipment.types.map((type, i) => (
                              <div className="checkbox-wrapper" key={i}>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={type.submitted}
                                    onChange={(e) => handleDocType(e, type)}
                                  />
                                  <span className="checkbox">
                                    <span>
                                      <svg
                                        width="15.668"
                                        height="15.51"
                                        viewBox="0 0 15.668 15.51"
                                      >
                                        <g transform="matrix(0.995, 0.105, -0.105, 0.995, -120.772, -167.938)">
                                          <line
                                            x2="5"
                                            y2="5"
                                            transform="translate(140.5 161.5)"
                                            fill="none"
                                            stroke="#f6fffb"
                                            strokeLinecap="round"
                                            strokeWidth="2"
                                          />
                                          <line
                                            x1="6"
                                            y2="12"
                                            transform="translate(146 155)"
                                            fill="none"
                                            stroke="#f6fffb"
                                            strokeLinecap="round"
                                            strokeWidth="2"
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  </span>
                                  <span>
                                    {type.type}
                                    {type.required ? "*" : null}
                                  </span>
                                </label>
                              </div>
                            ))}
                          </div>

                          <p>Documents Uploaded!</p>
                        </div>

                      </div>
                    </div>
                  )}

                  <div
                    className="form-step"
                    id="step-3"
                    style={isStep2Done() ? {} : ISFBlockedStep}
                  >
                    <div
                      className="circle-completed"
                      style={
                        shipment.status == "RELEASED"
                          ? greenAndBoldCircle
                          : opened3
                            ? {
                              backgroundColor: "var(--green)",
                            }
                            : {
                              border: "3px solid var(--border-color)",
                              backgroundColor: "white",
                            }
                      }
                    >
                      {/*Progress circle */}
                      {shipment.status == "RELEASED" ? (
                        <span style={greenAndBoldText}>✓</span>
                      ) : (
                        <span
                          style={
                            opened3
                              ? { color: "white" }
                              : { color: "black", fontWeight: "lighter" }
                          }
                        >
                          {step3Label}
                        </span>
                      )}
                    </div>

                    <div className="form-body">
                      <p className="form-title" onClick={toggleMenu3}>
                        <span
                          style={
                            shipment.status == "RELEASED" ||
                              shipment.status == "PENDING RELEASE" ||
                              opened3
                              ? greenAndBoldText
                              : { color: "black" }
                          }
                        >
                          Shipment Released
                        </span>
                        <span className="arrow">
                          {opened3 ? <ArrowUp /> : <ArrowDown />}
                        </span>
                      </p>
                      <div
                        className="form-content released-content"
                        style={contentDisplay3}
                      >
                        {shipment.status == "RELEASED" && (
                          <p>
                            {checkDateValidity(
                              shipment.shipment_discharge_date
                            ) === true
                              ? format(
                                new Date(shipment.shipment_discharge_date),
                                "MM/dd/yyyy"
                              )
                              : "NOT AVAILABLE"}
                          </p>
                        )}
                        {shipment.status == "RELEASED" &&
                          shipment.fda_review != null ? (
                          <p>FDA Status: {shipment.fda_review}</p>
                        ) : null}
                        {shipment.status == "PENDING RELEASE" && (
                          <p>Shipment is Awaiting Release</p>
                        )}
                        {shipment.status === "CBP INTENSIVE EXAM" ||
                          shipment.status === "CBP VACIS EXAM" ||
                          shipment.status === "CBP DOCS REVIEW HOLD" ||
                          shipment.status === "ISF HOLD" ? (
                          <p>{shipment.status}</p>
                        ) : null}
                      </div>
                    </div>

                  </div>
                </div>
                {!isShipmentsOnly && (
                  <div
                    className="update-order"
                    style={{
                      paddingBottom: "16px",
                    }}
                  >
                    <div className="update-header">
                      <div className="ignore-shipment-toggle">
                        <label>
                          <input
                            type="checkbox"
                            checked={shipment?.ignored_shipment?.WithoutDeliveryOrder || false} // Dynamically check based on the "WithoutDeliveryOrder" category
                            onChange={(e) =>
                              toggleIgnoreShipment(
                                shipment.id,
                                e.target.checked,
                                "WithoutDeliveryOrder" // Pass the category dynamically
                              )
                            } // Handle toggle with category
                          />
                          <span className="checkbox">
                            <span>
                              <svg
                                width="15.668"
                                height="15.51"
                                viewBox="0 0 15.668 15.51"
                              >
                                <g transform="matrix(0.995, 0.105, -0.105, 0.995, -120.772, -167.938)">
                                  <line
                                    x2="5"
                                    y2="5"
                                    transform="translate(140.5 161.5)"
                                    fill="none"
                                    stroke="#f6fffb"
                                    strokeLinecap="round"
                                    strokeWidth="2"
                                  />
                                  <line
                                    x1="6"
                                    y2="12"
                                    transform="translate(146 155)"
                                    fill="none"
                                    stroke="#f6fffb"
                                    strokeLinecap="round"
                                    strokeWidth="2"
                                  />
                                </g>
                              </svg>
                            </span>
                          </span>
                          <span className="checkbox-label">
                            Skip Delivery Order
                          </span>
                        </label>
                      </div>


                      <button
                        href="#"
                        onClick={() => {
                          setAditionalDelivery(aditionalDelivery + 1);
                        }}
                      >
                        New Delivery Order
                      </button>
                    </div>
                    <div>
                      {deliveryOrders({
                        numberOfDeliveries: shipment.delivery_orders,
                      })}
                    </div>
                  </div>
                )}
                {!isShipmentsOnly && (
                  <div className="notes">
                    <p className="title">Notes regarding shipment</p>
                    {shipment.shipment_notes?.filter((i) => i.role != 3)
                      .length ? (
                      shipment.shipment_notes?.filter((i) => i.role != 3)[
                        shipment.shipment_notes.filter((i) => i.role != 3)
                          .length - 1
                      ].comments.length > 0 ? (
                        <div className="note by-admin">
                          <p style={{ opacity: ".5" }}>
                            {
                              shipment.shipment_notes.filter((i) => i.role != 3)[
                                shipment.shipment_notes.filter((i) => i.role != 3)
                                  .length - 1
                              ].comments
                            }
                          </p>
                        </div>
                      ) : null
                    ) : null}
                    <div className="note-by-user">
                      <form onSubmit={handleNoteUpload} method="post">
                        <textarea
                          value={shipment.comment}
                          className="note-body"
                          onChange={(e) => {
                            setNoteSuccess(false);
                            shipment.comment = e.target.value;
                            setUserNote(e.target.value);
                          }}
                        />

                        {noteSuccess ? (
                          <p className="success-msg">
                            Note successfully submitted
                          </p>
                        ) : null}
                        <button
                          type="submit"
                          style={
                            userNote.length > 0
                              ? {
                                opacity: "1",
                                pointerEvents: "all",
                              }
                              : {
                                opacity: ".5",
                                pointerEvents: "none",
                              }
                          }
                        >
                          {noteLoading ? <LoadingIcon /> : "Submit"}
                        </button>
                      </form>
                    </div>
                  </div>
                )}
              </div>
              <div className="right-side">
                <div className="shipment-details">
                  <p className="title">Shipment Details</p>

                  <div className="info-box" id="info-box-1">
                    <div className="info-box-type">Account</div>
                    <div className="info-box-value">{shipment.account_no}</div>
                  </div>

                  <div className="info-box" id="info-box-1">
                    <div className="info-box-type">Container Number(s)</div>
                    <div className="info-box-value">{containerNumbers(shipment.containers)}</div>
                  </div>

                  <div className="info-box" id="info-box-2">
                    <div className="info-box-type">Reference Number</div>
                    <div className="info-box-value ref_no">
                      {isShipmentsOnly ? (
                        <span className="readonly-ref">
                          {shipment.customer_reference_no?.trim()?.length
                            ? shipment.customer_reference_no
                            : "NOT AVAILABLE"}
                        </span>
                      ) : (
                        <form method="post" onSubmit={handleRefNumberUpdate}>
                          <input
                            type="text"
                            placeholder={shipment.customer_reference_no}
                            value={newRefNumber}
                            onChange={(e) => setNewRefNumber(e.target.value)}
                          />
                          <button
                            type="submit"
                            style={
                              newRefNumber?.length > 0
                                ? { opacity: "1", pointerEvents: "all" }
                                : { opacity: ".5", pointerEvents: "none" }
                            }
                          >
                            {newRefNumber?.length > 0 ? <FaCheck className="green" /> : <FaPencilAlt />}
                          </button>
                        </form>
                      )}
                    </div>
                  </div>

                  {/* ISF Number (hide for air, trucker, rail) */}
                  {!isAir && !isTrucker && !isRail && (
                    <div className="info-box" id="info-box-3">
                      <div className="info-box-type">ISF Number</div>
                      <div className="info-box-value">{shipment.isf_transaction_no}</div>
                    </div>
                  )}

                  {shipment.master_bill_lading && shipment.master_bill_lading.length > 0 && (
                    <div className="info-box" id="info-box-4">
                      <div className="info-box-type">Master Bill of Lading</div>
                      <div className="info-box-value">{shipment.master_bill_lading}</div>
                    </div>
                  )}

                  {shipment.house_bill_lading && shipment.house_bill_lading.length > 0 && (
                    <div className="info-box" id="info-box-5">
                      <div className="info-box-type">House Bill of Lading</div>
                      <div className="info-box-value">{shipment.house_bill_lading}</div>
                    </div>
                  )}

                  <div className="info-box" id="info-box-6">
                    <div className="info-box-type">Origin</div>
                    <div className="info-box-value">{shipment.origin}</div>
                  </div>
                  <div className="info-box" id="info-box-7">
                    <div className="info-box-type">Destination</div>
                    <div className="info-box-value">
                      {shipment.unlading_code?.name === "Default" ? "" : shipment.unlading_code?.name}
                    </div>
                  </div>

                  <div className="info-box" id="info-box-8">
                    <div className="info-box-type">Destination Terminal</div>
                    <div className="info-box-value">{shipment.destination_terminal}</div>
                  </div>

                  {/* Steamship Line → Airline for air, hide for trucker */}
                  {!isTrucker && (
                    <div className="info-box" id="info-box-9">
                      <div className="info-box-type">{isAir ? "Airway" : isRail ? "Railway" : "Steamship Line"}</div>
                      <div className="info-box-value">{shipment.steamship_line}</div>
                    </div>
                  )}

                  {/* Vessel (hide for air) */}
                  {!isAir && (
                    <div className="info-box" id="info-box-10">
                      <div className="info-box-type">Vessel</div>
                      <div className="info-box-value">{shipment.vessel_name}</div>
                    </div>
                  )}

                  {shipment.weight && (
                    <div className="info-box" id="info-box-weight">
                      <div className="info-box-type">Weight</div>
                      <div className="info-box-value">{shipment.weight}</div>
                    </div>
                  )}

                  {shipment.pallets_cartons && (
                    <div className="info-box" id="info-box-pallets">
                      <div className="info-box-type">Pallets / Cartons</div>
                      <div className="info-box-value">{shipment.pallets_cartons}</div>
                    </div>
                  )}

                  <div className="info-box" id="info-box-11">
                    <div className="info-box-type">Mode of Transport</div>
                    <div className="info-box-value">
                      {shipment.transport_mode?.description?.replace("vessele:", "")}
                    </div>
                  </div>

                  <div className="info-box" id="info-box-12">
                    <div className="info-box-type">ETA</div>
                    <div className="info-box-value">
                      {checkDateValidity(shipment.est_time_arrive) === true
                        ? format(new Date(shipment.est_time_arrive), "MM/dd/yyyy")
                        : "NOT AVAILABLE"}
                    </div>
                  </div>

                  {/* ── Display on Homepage toggle ── */}
                  {!isShipmentsOnly && (
                    <div style={{ marginTop: "1rem", marginBottom: "0.75rem" }}>
                      <ToggleSwitch
                        label="Display on Homepage"
                        value={shipment?.show_on_home_user ? 1 : 0}
                        setValue={toggleShowOnHome}
                      />
                    </div>
                  )}

                  {shipment.documents?.length > 0 && !isShipmentsOnly && (
                    <button
                      onClick={openDocumentModal}
                      className="download-all-btn"
                      style={{ marginTop: "1rem", display: "block" }}
                    >
                      Download All Documents
                    </button>
                  )}
                </div>

                {/* ── Missing Information Checklist (Client Input) ── */}
                {missingInfos.length > 0 && (
                  <div className="missing-info-section">
                    <p className="missing-info-label">
                      Missing Information Checklist
                    </p>
                    <div className="missing-info-items">
                      {missingInfos.map((item) => (
                        <div
                          key={item.id}
                          className={`missing-info-item${item.checked ? " is-checked" : ""}`}
                        >
                          <div className="missing-info-row">
                            <div className={`missing-info-box${item.checked ? " is-checked" : ""}`}>
                              {item.checked && "✓"}
                            </div>
                            <span className={`missing-info-text${item.checked ? " is-checked" : ""}`}>
                              {item.text}
                            </span>
                          </div>

                          {!item.checked ? (
                            <div className="missing-info-input-row">
                              <input
                                type="text"
                                placeholder="Input missing information..."
                                value={responseValues[item.id] || ""}
                                onChange={(e) => handleResponseChange(item.id, e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    saveMissingInfoValue(item.id);
                                  }
                                }}
                              />
                              <button onClick={() => saveMissingInfoValue(item.id)}>
                                Save
                              </button>
                            </div>
                          ) : (
                            <div className="missing-info-response">
                              <strong>Response:</strong> {item.value}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}


                <div className="shipment-updates-wrapper">
                  {shipment.containers?.map((container, cIndex) => {
                    const tracking = container.tracking_info ? JSON.parse(container.tracking_info) : null;

                    if (!tracking) return null;

                    if (!tracking || !Array.isArray(tracking.events) || tracking.events.length === 0) {
                      return null;
                    }

                    // Hide if est_time_arrive is before 2025/08/01
                    const etaDate = new Date(shipment.est_time_arrive.replace(/-/g, '/'));
                    const cutoffDate = new Date('2025/08/01');
                    if (isNaN(etaDate.getTime()) || etaDate < cutoffDate) {
                      return null;
                    }
                    return (
                      <div
                        className={`shipment-updates ${opened1 === cIndex ? "open" : "closed"}`}
                        key={cIndex}
                      >
                        <p
                          className="title"
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpened1(opened1 === cIndex ? null : cIndex)}
                        >
                          Shipment Updates ({container.container_no}){" "}
                          {opened1 === cIndex ? <ArrowUp /> : <ArrowDown />}
                        </p>

                        {opened1 === cIndex &&
                          tracking.events?.map((event, index) => (
                            <div className="info-box no-border" key={index}>
                              <div className="info-box-type">
                                {event.location}
                              </div>
                              <div className="info-box-value" style={{ textTransform: 'capitalize' }}>
                                {event.type}
                              </div>
                              <div className="info-box-value">
                                {event.date}
                              </div>
                            </div>
                          ))}
                      </div>
                    );
                  })}
                </div>
                {state7501 !== null && !isShipmentsOnly && shipment?.status !== "IT SHIPMENT" ? (
                  <div
                    className="review-7501-toggle"
                    onClick={() => {
                      review7501(shipment?.id);
                    }}
                  >
                    <div className="checkbox-ship">
                      {state7501 == 0 ? "" : <p className="checked-item">✓</p>}
                    </div>
                    <p>7501 has been reviewed</p>
                  </div>
                ) : (
                  ""
                )}
                {!isShipmentsOnly && (
                  <div className="files">
                    <a
                      target={"_blank"}
                      className={`file ${shipment?.path_to_7501 ? "active-link" : "no-link"}`}
                      id="file-1"
                      href={
                        shipment?.path_to_7501
                          ? getFileUrl(shipment?.path_to_7501)
                          : `#`
                      }
                    >
                      <FileIcon />
                      <p>{shipment?.status === "IT SHIPMENT" ? "7512 Form" : "7501 Form"}</p>
                    </a>

                    {shipment?.invoices && shipment.invoices.length > 0 ? (
                      shipment.invoices.map((invoice, index) => (
                        <a
                          key={index}
                          target="_blank"
                          className="file active-link"
                          id={`file-invoice-${index}`}
                          href={getFileUrl(invoice.path)}
                        >
                          <FileIcon />
                          <p>Billing Invoice {index + 1}</p>
                        </a>
                      ))
                    ) : (
                      <a className="file no-link" id="file-no-invoice" href="#">
                        <FileIcon />
                        <p>Billing Invoice</p>
                      </a>
                    )}

                    {shipment.delivery_orders && shipment.delivery_orders.length > 0 ? (
                      shipment.delivery_orders
                        .filter((order) => order?.path?.length > 0)
                        .map((order, orderIndex) => (
                          <a
                            key={orderIndex}
                            href={getFileUrl(order.path)}
                            target="_blank"
                            className="file active-link"
                            id={`file-order-${orderIndex}`}
                          >
                            <div className="icon green">
                              <FileIcon />
                            </div>
                            <p>Delivery Order {orderIndex + 1}</p>
                          </a>
                        ))
                    ) : (
                      <a href="#" className="file no-link" id="file-no-delivery-order">
                        <FileIcon />
                        <p>Delivery Order</p>
                      </a>
                    )}
                  </div>
                )}
                {supplementaryFileArray?.length > 0 ? (
                  <section className={"supplementary-file-section"}>
                    <p className={"supplementary-files-title"}>
                      Additional Files
                    </p>
                    <div className="supplementary-files-container files">
                      {supplementaryFileArray.map((item, index) => {
                        const fileName = item?.path.slice(
                          item?.path.lastIndexOf("/") + 1
                        );
                        return (
                          <a
                            target={"_blank"}
                            className={"file active-link file-card"}
                            id={`file-${index + 4}`}
                            href={getFileUrl(item?.path)}
                            key={index}
                          >
                            <FileIcon />
                            <p className="file-card-name">{fileName}</p>
                          </a>
                        );
                      })}
                    </div>
                  </section>
                ) : (
                  <section></section>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {/* ── Document Selection Modal ── */}
      {showDocModal && (
        <div className="modal-overlay" onClick={() => setShowDocModal(false)}>
          <div
            className="modal doc-select-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="doc-select-header">
              <h3>Select Documents to Download</h3>
              <button
                className="close-modal"
                onClick={() => setShowDocModal(false)}
              >
                <IoCloseSharp size={16} />
              </button>
            </div>

            {docLoading ? (
              <div className="doc-select-loading">
                <LoadingIcon />
                <p>Loading documents…</p>
              </div>
            ) : docList.length === 0 ? (
              <p className="doc-select-empty">No documents found.</p>
            ) : (
              <>
                <div className="doc-select-controls">
                  <label className="doc-select-all">
                    <input
                      type="checkbox"
                      checked={selectedDocs.size === docList.length}
                      onChange={toggleSelectAll}
                    />
                    <span>
                      {selectedDocs.size === docList.length
                        ? "Deselect All"
                        : "Select All"}
                    </span>
                  </label>
                  <span className="doc-select-count">
                    {selectedDocs.size} of {docList.length} selected
                  </span>
                </div>

                <ul className="doc-select-list">
                  {docList.map((doc) => (
                    <li key={doc.path} className="doc-select-item">
                      <label>
                        <input
                          type="checkbox"
                          checked={selectedDocs.has(doc.path)}
                          onChange={() => toggleDocSelection(doc.path)}
                        />
                        <span className="doc-name">{doc.name}</span>
                        <span className="doc-ext">{doc.ext.toUpperCase()}</span>
                      </label>
                    </li>
                  ))}
                </ul>

                <div className="doc-select-actions">
                  <button
                    className="doc-select-cancel"
                    onClick={() => setShowDocModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="doc-select-download"
                    onClick={handleDownloadSelected}
                    disabled={selectedDocs.size === 0 || docDownloading}
                  >
                    {docDownloading
                      ? "Downloading..."
                      : `Download ${selectedDocs.size} File${selectedDocs.size !== 1 ? "s" : ""}`}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};